var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"mt-5",staticStyle:{"max-width":"-webkit-fill-available"}},[_c('v-flex',{attrs:{"grow":""}},[_c('VueApexCharts',{attrs:{"type":"area","options":_vm.chartOptions,"height":"350","series":_vm.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }